@use "../../styles/breakpoint.module.scss" as *;

.inner {
    composes: safeContainer from "../../styles/composable/layout.module.css";
}

.header {
    align-items: center;
    display: flex;
    flex-direction: column;
}

.galleryButton {
    margin-block: var(--spacer-24) var(--spacer-48);
}

.carouselArea {
    composes: grid from "../../styles/composable/layout.module.css";
    position: relative;
}

.carouselInner {
    grid-column: 5 / span 4;

    @media ($below-laptop) {
        grid-column: 4 / span 6;
    }

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.controls {
    inset-inline: 16%;

    @media ($below-tablet) {
        inset-inline: 0;
    }
}

.slide {
    width: 100%;
    vertical-align: top;
}

.facets {
    display: flex;
    justify-content: space-between;
    margin-block: var(--spacer-80) 0;

    @media ($below-tablet) {
        flex-wrap: wrap;
        gap: var(--spacer-24);
    }

    @media ($below-mobile) {
        flex-direction: column;
    }
}

.facet {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-4);

    @media ($above-mobile) and ($below-tablet) {
        flex: auto;
        width: calc(50% - var(--spacer-24));
    }
}

.facetLabel {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.facetValue {
    font: var(--font-h-32-forma);
    margin-left: 0;
    text-align: center;
}
